// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Badge.module.scss  */
.Badge-module-Root_1dY {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  font-family: var(--badge-font-family);
  font-size: var(--badge-font-size);
  line-height: var(--badge-line-height);
  text-align: center; }

.Badge-module-filledVariant_1Oz {
  color: var(--color-background-base);
  border: 1px solid var(--badge-color);
  background-color: var(--badge-color); }

.Badge-module-outlinedVariant_zRH {
  color: var(--badge-color);
  border: 1px solid var(--badge-color);
  background-color: var(--color-background-base); }

.Badge-module-sRoundness_2DA {
  border-radius: 1px; }

.Badge-module-mRoundness_3j8 {
  border-radius: 8px; }

.Badge-module-lRoundness_2sp {
  border-radius: 999px; }

.Badge-module-sSize_lGc {
  height: var(--badge-s-size);
  padding: 0 5px;
  font-size: calc(var(--badge-font-size) * 0.8); }

.Badge-module-mSize_2GX {
  height: var(--badge-m-size);
  padding: 0 6px; }

.Badge-module-lSize_2U4 {
  height: var(--badge-l-size);
  padding: 0 12px;
  font-weight: var(--badge-font-weight); }

.Badge-module-isEmpty_2A- {
  width: 6px;
  height: 6px;
  padding: 0;
  border-radius: 50%; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Badge/Badge.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB,EAAE;;AAEtB;EACE,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8CAA8C,EAAE;;AAElD;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB,EAAE;;AAEtB;EACE,oBAAoB,EAAE;;AAExB;EACE,2BAA2B;EAC3B,cAAc;EACd,6CAA6C,EAAE;;AAEjD;EACE,2BAA2B;EAC3B,cAAc,EAAE;;AAElB;EACE,2BAA2B;EAC3B,eAAe;EACf,qCAAqC,EAAE;;AAEzC;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB,EAAE","sourcesContent":["/*  imported from Badge.module.scss  */\n.Badge-module-Root_1dY {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  font-family: var(--badge-font-family);\n  font-size: var(--badge-font-size);\n  line-height: var(--badge-line-height);\n  text-align: center; }\n\n.Badge-module-filledVariant_1Oz {\n  color: var(--color-background-base);\n  border: 1px solid var(--badge-color);\n  background-color: var(--badge-color); }\n\n.Badge-module-outlinedVariant_zRH {\n  color: var(--badge-color);\n  border: 1px solid var(--badge-color);\n  background-color: var(--color-background-base); }\n\n.Badge-module-sRoundness_2DA {\n  border-radius: 1px; }\n\n.Badge-module-mRoundness_3j8 {\n  border-radius: 8px; }\n\n.Badge-module-lRoundness_2sp {\n  border-radius: 999px; }\n\n.Badge-module-sSize_lGc {\n  height: var(--badge-s-size);\n  padding: 0 5px;\n  font-size: calc(var(--badge-font-size) * 0.8); }\n\n.Badge-module-mSize_2GX {\n  height: var(--badge-m-size);\n  padding: 0 6px; }\n\n.Badge-module-lSize_2U4 {\n  height: var(--badge-l-size);\n  padding: 0 12px;\n  font-weight: var(--badge-font-weight); }\n\n.Badge-module-isEmpty_2A- {\n  width: 6px;\n  height: 6px;\n  padding: 0;\n  border-radius: 50%; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
